import { tv } from '~/utils/tv'

export const labelVariants = tv({
  base: ' mb-halfpulse block h-auto max-w-full overflow-hidden text-ellipsis whitespace-nowrap px-onepulse text-left font-rdmodern font-regular text-text-neutral leading-[var(--line-height-none)]',
  variants: {
    size: {
      md: 'text-threepulse',
      ml: 'text-threeandhalfpulse',
      lg: 'text-threeandhalfpulse',
      xl: 'text-threeandhalfpulse',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
    readonly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
